/**
 * @typedef {import('../../../interfaces/AUI/IDropdownButton.interface').IDropdownButtonItem} IDropdownButtonItem
 */

import React from 'react';
import { AUIButtonCell, AUIDropdownButtonCell, AUIIconCell } from '@ancert/aui-table-cell';
import TIPO_ADJUNTO from '../../../lib/adjuntos.enum';
import { getFileIcon } from '../../../utils/fileUtils';

/**
 * @typedef {object} events
 * @property {Function} onRowEditar
 * @property {Function} onRowEliminar
 * @property {Function} onRowVer
 */

/**
 * @param {events} events
 * @param {object} row
 * @returns {Array<IDropdownButtonItem>}
 */
const getItems = ({ onRowEditar, onRowEliminar }, row) => {
  const { type } = row;
  const eliminar = { label: 'Eliminar', command: () => onRowEliminar(row) };
  if (type === TIPO_ADJUNTO.MP3) {
    return [eliminar];
  }
  return [{ label: 'Editar', command: () => onRowEditar(row) }, eliminar];
};

/**
 * @param {events} events
 * @param {boolean} viewMode
 * @returns
 */
const getColumns = (events, viewMode) => [
  {
    id: 'name',
    accessor: (row) => row.name,
    columnWidth: 240,
    header: 'Fichero',
    cell: ({ value }) => <AUIIconCell icon={getFileIcon(value)} description={value} />,
  },
  {
    id: 'descripcion',
    accessor: (row) => row.description,
    header: 'Descripción',
    cell: ({ value }) => <>{value}</>,
  },
  {
    id: 'action',
    columnWidth: viewMode ? 80 : 40,
    accessor: (row) => row,
    header: '',
    cell: ({ value }) => {
      if (viewMode) {
        return (
          <AUIButtonCell buttonList={[{ mode: 'ghost', label: 'Descargar', onClick: () => events.onRowVer(value) }]} />
        );
      }
      return <AUIDropdownButtonCell items={getItems(events, value)} />;
    },
  },
];

export default getColumns;
